import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas/rootSaga'
import rootReducer from './reducer/rootReducer';

const sagaMiddleWare = createSagaMiddleware();

export const store = configureStore({
  reducer:rootReducer,
  middleware:(getDefaultMiddleware) =>getDefaultMiddleware().concat(sagaMiddleWare)
})

sagaMiddleWare.run(rootSaga)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch